import React, { useState, useEffect, useContext } from 'react'
import { useTranslation } from 'react-i18next';

import styles from './styles.module.css'
import { mainContext } from '../../../MainContext';
import FadeinWrap from '../../../../common/animation/FadeinWrap';


function ContainerLesson() {
  const { t } = useTranslation();


  useEffect(() => {
  }, [])


  return (
    <div className={`${styles.wrap} margin-horizontal-auto`}>
      <FadeinWrap>
        <img src={t('lesson.img')} className={styles.lessonImg} alt="" />
      </FadeinWrap>

      <p className={styles.discription}>
        {t('lesson.content').split('\n').map((line, index) => (
          <React.Fragment key={index}>
            {line}
            <br />
          </React.Fragment>
        ))}
      </p>
    </div>
  );
}

export default ContainerLesson;